export const RtlLanguages = new Set(['Arabic', 'Hebrew']);

export function isRtlLanguage(language: string) {
  return RtlLanguages.has(language);
}
